var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "avatar" }, [
    _vm.loading
      ? _c("div", { staticClass: "avatar-loading" })
      : _c("div", { style: { backgroundImage: _vm.avatarImage } }, [
          !_vm.avatarImage
            ? _c("span", { staticClass: "avatar-initials" }, [
                _vm._v(_vm._s(_vm.initials))
              ])
            : _vm._e()
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63e265d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63e265d8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserIcon.vue
// module id = null
// module chunks = 